module.exports = __webpack_public_path__ + "static/media/star.2fe7fa06.svg";